import adminApiClient from './api.admin';
import ADMIN_API_ENDPOINTS from './endpoints.admin';
class AdminSubcategoriesService {
    async list() {
        // El endpoint usa GET para obtener la lista
        return adminApiClient.get(ADMIN_API_ENDPOINTS.SUBCATEGORIES.BASE);
    }
    async get(id) {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.SUBCATEGORIES.BY_ID(id));
    }
    async create(payload) {
        return adminApiClient.post(ADMIN_API_ENDPOINTS.SUBCATEGORIES.BASE, payload);
    }
    async update(id, payload) {
        // El endpoint de actualización usa POST
        return adminApiClient.post(ADMIN_API_ENDPOINTS.SUBCATEGORIES.UPDATE(id), payload);
    }
    async remove(id) {
        return adminApiClient.delete(ADMIN_API_ENDPOINTS.SUBCATEGORIES.BY_ID(id));
    }
}
export const adminSubcategoriesService = new AdminSubcategoriesService();
export default adminSubcategoriesService;
